import React, { useState } from 'react';
import './settings.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import GetLangConfig from '../../../util/LangUtil';
import { TextField } from '@mui/material';

interface HandleError {
    handleError: Function;
}

export default function AdminSettings(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');
    const client = new DrugExceptionsClient();
    const langConfig = GetLangConfig('settings');

    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [password2, setPassword2] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const passwordsMismatch = password !== '' && password2 !== '' && password !== password2;

    const changePassword = async () => {
        if (password === '' || password2 === '' || currentPassword === '') {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Passwords cannot be empty!']
                    }
                }
            });
            return;
        }

        if (password !== password2) {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: ['Passwords do not match!']
                    }
                }
            });
            return;
        }

        try {
            setLoading(true);
            const payload = {
                oldPassword: currentPassword,
                newPassword: password
            };

            await client.api.post('/users/changepassword', payload, {
                headers: {
                    Authorization: `Bearer ${userId.authToken}`
                }
            });

            props.handleError({
                error: false,
                ajax: {
                    request: {
                        responseText: ['Password changed successfully']
                    }
                }
            });
        } catch (error) {
            props.handleError(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-settings-container">
            <div className="header">
                <h1>{langConfig.settings.label1}</h1>
            </div>
            <div className="settings">
                <div>
                    <div className="account-details">
                        <h1>{langConfig.settings.label2}</h1>
                        <h3>{userIdentityObject.firstName} {userIdentityObject.lastName}</h3>
                        <div className="detail-group">
                            <div className="detail-label">{langConfig.general.email}:</div>
                            <div className="detail-info">{userIdentityObject.identity.email}</div>
                        </div>
                    </div>
                    <div className="change-password">
                        <h1>{langConfig.settings.label6}</h1>

                        <TextField
                            id="current-password"
                            label={langConfig.settings.pwdtext1 + '*'}
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                            variant="filled"
                            margin="normal"
                            type="password"
                            fullWidth
                            disabled={loading}
                        />

                        <TextField
                            id="new-password"
                            label={langConfig.settings.pwdtext2 + '*'}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            variant="filled"
                            margin="normal"
                            type="password"
                            fullWidth
                            disabled={loading}
                            error={passwordsMismatch}
                        />

                        <TextField
                            id="confirm-password"
                            label={langConfig.settings.pwdtext3 + '*'}
                            value={password2}
                            onChange={(e) => setPassword2(e.target.value)}
                            variant="filled"
                            margin="normal"
                            type="password"
                            fullWidth
                            disabled={loading}
                            error={passwordsMismatch}
                        />

                        <div>
                            <button
                                className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped"
                                onClick={changePassword}
                                disabled={loading}
                            >
                                <div className="mdc-button__ripple"></div>
                                <span className="mdc-button__label">{langConfig.settings.label8}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
